import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, CardBody, Row, Col } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import FileUpload from "components/Common/file-upload/file-upload.component";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import CancelModal from "components/CancelModal";
import SalesRepsService from "services/Admin/SalesRepsService";
import CompoundService from "services/Admin/CompoundService";
import BuildingService from "services/Admin/BuildingService";
import PropertyService from "services/Admin/PropertyService";
import DealService from "services/Admin/DealService";
import LeadService from "services/Admin/LeadService";
import CustomSelect from "../Select";
import SelectOptions from "../SelectOption";
import Select from "react-select";
import SuccessModal from "components/SucessModal";
import { unitTypeOptions } from "Enums/fixedData";
import ResaleService from "services/Admin/ResaleService";
import { info } from "toastr";
const initialState = {
	title: "",
	name: "",
	email: "",
	phone: "",
	description: "",
	sales_rep_id: null,
	unitType: null,
	selectedLead: null,
};

const AddLeadPage = (props) => {
	const owner = props.match.params.owner;
	const id = props.match.params.id;
	const dealService = new DealService();
	const leadService = new LeadService();
	const salesRepsService = new SalesRepsService();
	const buildingService = new BuildingService();
	const propertyService = new PropertyService();
	const resaleService = new ResaleService();
	const compoundService = new CompoundService();
	const [formState, setFormState] = useState(initialState);
	const [modal, setModal] = useState(false);
	const [successModal, setSuccessModal] = useState(false);
	const [salesRepOptions, setSalesRepOptions] = useState([]);
	const [CompoundOptions, setCompoundptions] = useState([]);
	const [buildingOptions, setBuildingOptions] = useState([]);
	const [propertyOptions, setPropertyOptions] = useState([]);
	const [resaleOption, setResaleOption] = useState([]);
	const [unitType, setUnitType] = useState("");
	const [leadsOptions, setLeadOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [validate, setValidate] = useState({
		sales_rep_id: null,
		selectedCompound: null,
		selectedProperty: null,
		selectedLead: null,
		unitType: null,
	});

	useEffect(() => {
		const id = formState?.selectedCompound?.value;
		if (id && formState?.unitType?.label === "Property in Compound") {
			buildingService.getDropDown(id).then((res) => {
				const newOptions = res.data.map((item) => {
					return {
						label: item.name.en,
						value: item.id,
					};
				});
				setBuildingOptions(newOptions);
			});
		}
	}, [formState.selectedCompound]);

	useEffect(() => {
		const id = formState?.selectedBulding?.value;
		if (id) {
			propertyService.getDropDown(id).then((res) => {
				const newOptions = res.data.map((item) => {
					return {
						label: item.name.en,
						value: item.id,
					};
				});
				setPropertyOptions(newOptions);
			});
		}
	}, [formState.selectedBulding]);

	useEffect(() => {
		const id = formState?.selectedCompound?.value;
		if (id && formState?.unitType?.label === "Property in Compound") {
			propertyService.getDropDownCustom(id).then((res) => {
				const newOptions = res.data?.map((item) => {
					return {
						label: item.name.en,
						value: item.id,
					};
				});
				setPropertyOptions(newOptions);
			});
		} else if (id && formState?.unitType?.label === "Resale in Compound") {
			resaleService.getResaleInCompoundDropDown(id).then((res) => {
				const newOptions = res.data?.map((item) => {
					return {
						label: item.name.en,
						value: item.id,
					};
				});
				setResaleOption(newOptions);
			});
		}
	}, [formState.selectedCompound]);

	useEffect(() => {
		if (id && leadsOptions.length > 0) {
			const selectedLead = leadsOptions.find((lead) => {
				return parseInt(lead.value) === parseInt(id);
			});
			setFormState({
				...formState,
				selectedLead,
			});
		}
	}, [leadsOptions]);

	useEffect(() => {
		salesRepsService.getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en ? item.name.en : item.name,
					value: item.id,
				};
			});
			let selectedOwner = newOptions.find(
				(option) => parseInt(option.value) === parseInt(owner)
			);
			setFormState((formState) => ({
				...formState,
				sales_rep_id: selectedOwner,
			}));
			setSalesRepOptions(newOptions);
		});
	}, [owner]);

	useEffect(() => {
		if (formState?.unitType?.label === "Resale Unit Outside Compound") {
			resaleService.getIndependentResaleDropDown().then((res) => {
				const newOptions = res.data.map((item) => {
					return {
						label: item.name.en ? item.name.en : item.name,
						value: item.id,
					};
				});
				setResaleOption(newOptions);
			});
		}
		if (formState?.unitType?.label === "Resale in Compound") {
			compoundService.getCompoundWithResaleDropDown().then((res) => {
				const newOptions = res.data.map((item) => {
					return {
						label: item.name.en ? item.name.en : item.name,
						value: item.id,
					};
				});
				setCompoundptions(newOptions);
				setResaleOption([]);
			});
		}
		if (formState?.unitType?.label === "Property in Compound") {
			setCompoundptions([]);
		}
	}, [formState.unitType]);

	useEffect(() => {
		leadService.getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: `${item.id} / ${item.name}`,
					value: item.id,
				};
			});
			setLeadOptions(newOptions);
		});
	}, []);

	const handleValidSubmit = (e, v) => {
		if (
			(formState?.unitType?.label === "Property in Compound" &&
				!formState.selectedCompound) ||
			(formState?.unitType?.label === "Property in Compound" &&
				!formState.selectedProperty)
		) {
			if (!formState.selectedCompound) {
				toast.error("please select Compound");
				return;
			}
			if (!formState.selectedProperty) {
				toast.error("please select Property");
				return;
			}
		} else if (
			(formState?.unitType?.label === "Resale in Compound" &&
				!formState.selectedCompound) ||
			(formState?.unitType?.label === "Resale in Compound" &&
				!formState.selectedResale)
		) {
			if (!formState.selectedCompound) {
				toast.error("please select Compound");
				return;
			}
			if (!formState.selectedResale) {
				toast.error("please select Resale");
				return;
			}
		} else if (
			formState?.unitType?.label === "Resale Unit Outside Compound" &&
			!formState.selectedResale
		) {
			toast.error("please select Resale");
			return;
		} else if (
			formState?.unitType?.label === "other" &&
			!formState.resale_name
		) {
			toast.error("Please Enter Resale Name");
			return;
		} else {
			setLoading(true);
			let info;
			if (formState?.unitType?.label === "Property in Compound") {
				info = {
					compound_id: formState?.selectedCompound?.value,
					building_id: formState?.selectedBulding?.value,
					unit_id: formState.selectedProperty.value,
				};
			} else if (formState?.unitType?.label === "Resale in Compound") {
				info = {
					compound_id: formState?.selectedCompound?.value,
					resale_id: formState.selectedResale.value,
				};
			} else if (
				formState?.unitType?.label === "Resale Unit Outside Compound"
			) {
				info = {
					resale_id: formState.selectedResale.value,
				};
			} else {
				info = {
					other: formState.resale_name,
				};
			}
			const data = {
				...info,
				title: formState.title,
				description: formState.description,
				lead_id: formState.selectedLead.value,
				sales_rep_id: formState.sales_rep_id.value,
			};

			dealService.create(data).then((response) => {
				if (response && response.status === SuccessCreated) {
					setSuccessModal(true);
				}
				setLoading(false);
			});
		}
	};

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>Add Deal</title>
				</MetaTags>
				<Container fluid>
					<h4>
						{/* <button className="p-0 m-0 border-0 bg-light"
                            onClick={() => {
                                setModal(true)
                            }}>
                            <i className="fa fa-arrow-left text-primary me-2"></i>
                        </button> */}
						Add New Deal
					</h4>
					<AvForm
						className="form-horizontal min-h-75vh"
						onValidSubmit={(e, v) => {
							handleValidSubmit(e, v);
						}}>
						<Card className="w-100 mt-4">
							<CardBody>
								<Row className="mb-4">
									<Col md={6}>
										<div className="mt-2">
											<AvField
												name="title"
												label="Deal Title"
												className="form-control"
												placeholder="Type Deal Title"
												errorMessage="This Field is Required"
												required
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
												value={formState.title}
											/>
										</div>
									</Col>
									<CustomSelect
										label={"Client Name"}
										id={"leadOptions"}
										className="mt-2"
										options={leadsOptions}
										selected={formState.selectedLead}
										validate={validate.selectedLead}
										setOptions={(options) => setLeadOptions(options)}
										setFormState={(data) => {
											setFormState({ ...formState, selectedLead: data });
										}}
									/>
									<CustomSelect
										id={"salesRepOptions"}
										label={"Sales Rep"}
										className="mt-2"
										placeholder="Select"
										options={salesRepOptions}
										selected={formState.sales_rep_id}
										validate={validate.sales_rep_id}
										setOptions={(options) => setSalesRepOptions(options)}
										setFormState={(data) => {
											setFormState({ ...formState, sales_rep_id: data });
										}}
									/>
									<CustomSelect
										id={"unitTypeOptions"}
										label={"Select Unit Type"}
										className="mt-2"
										options={unitTypeOptions}
										validate={validate.unitType}
										selected={formState.unitType}
										setOptions={(options) => setUnitType(options)}
										setFormState={(data) => {
											if (
												data?.label === "Property in Compound" ||
												data?.label === "Resale in Compound"
											) {
												setFormState({
													...formState,
													unitType: data,
													selectedCompound: null,
												});
											} else if (
												data?.label === "Resale Unit Outside Compound"
											) {
												setFormState({
													...formState,
													unitType: data,
													selectedResale: null,
												});
											} else {
												setFormState({
													...formState,
													unitType: data,
													selectedCompound: null,
													selectedResale: null,
												});
											}
										}}
									/>
									{!!formState.unitType &&
										formState.unitType.label === "Property in Compound" && (
											<>
												<SelectOptions
													Service={CompoundService}
													id={"CompoundOptions"}
													label={"Compound"}
													className="mt-2"
													options={CompoundOptions}
													selected={formState.selectedCompound}
													setOptions={(options) => setCompoundptions(options)}
													setFormState={(data) => {
														setFormState({
															...formState,
															selectedCompound: data,
															selectedBulding: null,
															selectedProperty: null,
														});
													}}
												/>
												<Col md={6} className="mt-2">
													<label>Building</label>
													<Select
														placeholder="Select"
														className="mt-2"
														options={buildingOptions}
														onChange={(data) =>
															setFormState({
																...formState,
																selectedBulding: data,
																selectedProperty: null,
															})
														}
														value={formState.selectedBulding}
														setOptions={(options) =>
															setBuildingOptions(options)
														}
													/>
												</Col>
												<CustomSelect
													id={"propertyOptions"}
													label={"Property"}
													className="mt-2"
													options={propertyOptions}
													selected={formState.selectedProperty}
													setOptions={(options) => setPropertyOptions(options)}
													setFormState={(data) => {
														setFormState({
															...formState,
															selectedProperty: data,
														});
													}}
												/>
											</>
										)}
									{!!formState.unitType &&
										formState.unitType.label === "Resale in Compound" && (
											<>
												<Col md={6} className="mt-2">
													<label>Compound</label>
													<Select
														id={"CompoundOptions"}
														label={"Compound"}
														options={CompoundOptions}
														value={formState.selectedCompound}
														onChange={(data) => {
															setFormState({
																...formState,
																selectedCompound: data,
																selectedResale: null,
															});
														}}
													/>
												</Col>
												<Col md={6} className="mt-2">
													<label>Resale</label>
													<Select
														placeholder="Select"
														options={resaleOption}
														onChange={(data) =>
															setFormState({
																...formState,
																selectedResale: data,
															})
														}
														value={formState.selectedResale}
													/>
												</Col>
											</>
										)}
									{!!formState.unitType &&
										formState.unitType.label ===
											"Resale Unit Outside Compound" && (
											<>
												<Col md={6} className="mt-2">
													<label>Resale</label>
													<Select
														placeholder="Select"
														options={resaleOption}
														onChange={(data) =>
															setFormState({
																...formState,
																selectedResale: data,
															})
														}
														value={formState.selectedResale}
													/>
												</Col>
											</>
										)}
									{!!formState.unitType &&
										formState.unitType.label === "Other" && (
											<>
												<Col md={6} className="mt-2">
													<AvField
														name="resale_name"
														label="Resale Name"
														placeholder="Resale Name"
														className="form-control"
														type="text"
														onChange={(e) => handleFieldChange(e)}
														bsSize="lg"
														value={formState.resale_name}
													/>
												</Col>
											</>
										)}
									{/* <SelectOptions
                                        Service={CompoundService}
                                        id={"CompoundOptions"}
                                        label={"Compound"}
                                        options={CompoundOptions}
                                        selected={formState.selectedCompound}
                                        validate={validate.selectedCompound}
                                        setOptions={options => setCompoundptions(options)}
                                        setFormState={(data) => {
                                            setFormState({ ...formState, selectedCompound: data })

                                        }}
                                    /> */}
									{/* <Col md={6} className="mt-2">
                                        <label>Building</label>
                                        <Select
                                            placeholder='Select'
                                            options={buildingOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedBulding: data, selectedProperty: null })}
                                            value={formState.selectedBulding}
                                            setOptions={options => setBuildingOptions(options)}
                                        />
                                    </Col> */}
									{/* <CustomSelect
                                        id={"propertyOptions"}
                                        label={"Property"}
                                        options={propertyOptions}
                                        selected={formState.selectedProperty}
                                        validate={validate.selectedProperty}
                                        setOptions={options => setPropertyOptions(options)}
                                        setFormState={(data) => {
                                            setFormState({ ...formState, selectedProperty: data })
                                        }} /> */}
									<Col md={12}>
										<div className="mt-2">
											<AvField
												name="description"
												label="Description"
												placeholder="Type Description"
												className="form-control"
												type="textarea"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
												value={formState.description}
											/>
										</div>
									</Col>
								</Row>
							</CardBody>
						</Card>
						<Row className="d-flex justify-content-between pb-4">
							<Col>
								<button
									type="button"
									className="btn btn-light btnHeight px-4"
									onClick={() => {
										setModal(true);
									}}
									size={"lg"}>
									Cancel
								</button>
							</Col>
							<Col>
								<button
									type="submit"
									className="btn btn-success btnHeight px-4 float-end"
									size={"lg"}
									disabled={loading ? true : false}
									onClick={() => {
										let obj = {};
										for (let key in validate) {
											if (formState[key]) {
												obj[key] = false;
											} else {
												obj[key] = true;
											}
										}
										setValidate({ ...obj });
									}}>
									Submit
								</button>
							</Col>
						</Row>
						<CancelModal
							modal={modal}
							setModal={setModal}
							goBackHandler={() => props.history.goBack()}
						/>
					</AvForm>
					<SuccessModal
						modal={successModal}
						message={
							props.id
								? "Edited Deal Successfully"
								: "New Deal Added Successfully"
						}
						onClick={() => {
							props.history.goBack();
						}}
						title={props.id ? "Edit Deal " : "Add New Deal"}
					/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default AddLeadPage;
